import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import OneAudienceImage from './OneAudienceImage'

const copy = {
  title: `One audience to build your marketing around`,
  description: `Segment and sync audiences leveraging a unified customer profile in real-time to marketing automation tools, ads platforms, analytics tools, data warehouses and more.`,
  list: [
    {
      title: `Complete real-time data, complete understanding`,
      description: `Gain a deep understanding of your customer behavior as it evolves in real-time across web, mobile, server, and third-party touchpoints to create and leverage audiences wherever you need them.`,
    },
    {
      title: `Activate audiences on an extensive platform`,
      description: `With access to the widest breadth of digital channels and tools by way of 450+ integrations, you get increased agility to meet your customer’s needs at every step of the journey with a single unified audience.`,
    },
  ],
}

const OneAudience = () => {
  return (
    <SectionBase sticky={true} variant="2Col" reverse={true}>
      <Section.Contents>
        <Section.Sticky>
          <OneAudienceImage />
        </Section.Sticky>
      </Section.Contents>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <StyledColumnTrack>
            {copy.list.map(({ title, description }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="h5">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p" variant="pMedium">
                  {description}
                </CopyText.Description>
              </CopyTextBase>
            ))}
          </StyledColumnTrack>
        </CopyTextBase>
      </Section.Copy>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  margin-top: 48px;
`

export default OneAudience
